<template>
    <div class="spec-item">
        <div class="label">
            <template v-if="hasLabelSlot">
                <slot name="label"></slot>
            </template>
            <template v-else>{{ label }}</template>
            <ahTip v-if="tip">{{ tip }}</ahTip>
        </div>
        <div class="value">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        tip: {
            type: String,
            default: null,
        },
    },
    computed: {
        hasLabelSlot() {
            return !!this.$slots.label;
        },
    },
};
</script>
<style lang="scss">
.spec-view {
    .spec-item {
        display: table-row;

        .label {
            display: table-cell;
            width: 140px;
            padding: 2px 0;
        }
        .value {
            display: table-cell;
            padding: 2px 0;
        }
    }
}
</style>
